import CheckBoxPaymentMethod from "./CheckBoxPaymentMethod/CheckBoxPaymentMethod";
import SelectComponent from "./SelectComponent";
import WhyChooseHome from "./WhyChooseHome";
export { SelectComponent, CheckBoxPaymentMethod, WhyChooseHome };
